if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
      BSS_B2B.observer.cartSubject.notifyObserver("CartMutate","CartPriceMutate");
      BSS_B2B.observer.cartSubject.listenCartCheckout()

      if (window.location.href.includes("/collections") || window.location.href.includes("/search-results-page")) {
        updateProductAttributes();
        handleLazyLoad();
      }
    }, 2000);

      setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
          // console.log(MutationList)
          for (let item of MutationList) {
            if (item.target.classList.contains("ajax-cart__cart-item-count")) {
                BSS_B2B.observer.cartSubject.listenCartCheckout()
            }
            if (item.target.classList.contains("collection") || item.target.classList.contains("snize-filters-sidebar")) {
              setTimeout(() => {
                updateProductAttributes();
                handleLazyLoad();
              }, 1500);
            }            
            if (item.target.id === "snize-instant-search-results") {
              setTimeout(() => {
                updateProductAttributesSearchBar();
                handleLazyLoad();
              }, 1500);
            }
          }
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      }, 300);
    
    function updateProductAttributes() {
      document
        .querySelectorAll(".snize-search-results-main-content li.snize-product")
        .forEach((li) => {
          const productId = li.getAttribute("data-original-product-id");
          const priceElement = li.querySelector(".snize-price.money");

          if (productId && priceElement) {
            priceElement.setAttribute("bss-b2b-product-id", productId);
            priceElement.setAttribute("bss-b2b-product-price", "");
          }
        });
    }

    function updateProductAttributesSearchBar() {
      document
        .querySelectorAll(
          ".snize-ac-results-singlecolumn-list li.snize-product"
        )
        .forEach((li) => {
          const productId = li.getAttribute("data-original-product-id");
          const priceElement = li.querySelector(".snize-price.money");

          if (productId && priceElement) {
            priceElement.setAttribute("bss-b2b-product-id", productId);
            priceElement.setAttribute("bss-b2b-product-price", "");
          }
        });
    }

    async function handleLazyLoad() {
      if (BSS_B2B) {
        const res = await BSS_B2B.storage.productStorage.load();
        if (res) {
          if (
            res.notExistProductIds?.length ||
            res.productIds?.length ||
            res.variantIds?.size
          ) {
            BSS_B2B.observer.productSubject.notifyObserver(
              "LazyProduct",
              "LoadedLazyProduct",
              {
                ...res,
              }
            );
          }
        }
      }
    }
    
  });
}
